module.exports = __webpack_public_path__ + "s.no2.8af0db5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/s.no2.jpg
// module id = oln6
// module chunks = 0